module.exports = __webpack_public_path__ + "img/icon_classify10.b28e1b2a.png";